module.exports = __webpack_public_path__ + "static/media/social-facebook.c60312cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-facebook.svg
// module id = 89
// module chunks = 0